import api from "../../lib/api";
import { auth } from "../../lib/firebase";

const SET_DASHBOARD_STATS = 'SET_DASHBOARD_STATS';
const SET_SECRETARY_CONFIG = 'SET_SECRETARY_CONFIG';
const SET_FAQ_ITEMS = 'SET_FAQ_ITEMS';
const ADD_FAQ_ITEM = 'ADD_FAQ_ITEM';
const UPDATE_FAQ_ITEM = 'UPDATE_FAQ_ITEM';
const DELETE_FAQ_ITEM = 'DELETE_FAQ_ITEM';
const SET_MESSAGE_TEMPLATES = 'SET_MESSAGE_TEMPLATES';
const ADD_MESSAGE_TEMPLATE = 'ADD_MESSAGE_TEMPLATE';
const SET_MESSAGE_HISTORY = 'SET_MESSAGE_HISTORY';
const ADD_MESSAGE_HISTORY = 'ADD_MESSAGE_HISTORY';
const SET_LOADING = 'SET_LOADING';
const SET_SAVING = 'SET_SAVING';
const SET_READONLY_SECRETARY = 'SET_READONLY_SECRETARY';
const SET_SECRETARY_STATS = 'SET_SECRETARY_STATS';
const RESET = 'RESET';

const GET_DASHBOARD_STATS = 'GET_DASHBOARD_STATS';
const GET_SECRETARY_CONFIG = 'GET_SECRETARY_CONFIG';
const GET_FAQ_ITEMS = 'GET_FAQ_ITEMS';
const GET_ACTIVE_FAQ_ITEMS = 'GET_ACTIVE_FAQ_ITEMS';
const GET_FAQ_CATEGORIES = 'GET_FAQ_CATEGORIES';
const GET_MESSAGE_TEMPLATES = 'GET_MESSAGE_TEMPLATES';
const GET_MESSAGE_HISTORY = 'GET_MESSAGE_HISTORY';
const GET_RECENT_MESSAGES = 'GET_RECENT_MESSAGES';
const GET_ACTIVE_SECRETARY_STATUS = 'GET_ACTIVE_SECRETARY_STATUS';
const GET_MONTHLY_USAGE_PERCENTAGE = 'GET_MONTHLY_USAGE_PERCENTAGE';
const GET_MESSAGES_BY_CHANNEL = 'GET_MESSAGES_BY_CHANNEL';
const GET_IS_LOADING = 'GET_IS_LOADING';
const GET_IS_SAVING = 'GET_IS_SAVING';
const GET_SECRETARY_STATS = 'GET_SECRETARY_STATS';

const getDefaultState = () => {
  return {
    readonlySecretary: null,
    stats: {},
    dashboardStats: {
      messages: 47,
      cost: '23.50',
      responseRate: 85,
      isActive: true,
      monthlyLimit: 100,
      costPerMessage: 0.50
    },
    secretaryConfig: {},
    faqItems: [],
    messageTemplates: {
      patients: [
        {
          id: 1,
          name: 'Lembrete de Consulta',
          content: 'Olá {nome}! Lembramos que você tem consulta marcada para {data} às {hora} com {profissional}. Confirme sua presença respondendo SIM ou reagende respondendo REAGENDAR.',
          variables: ['nome', 'data', 'hora', 'profissional'],
          active: true,
          category: 'reminder',
          createdAt: '2024-06-20T10:00:00Z'
        },
        {
          id: 2,
          name: 'Confirmação de Agendamento',
          content: 'Olá {nome}! Sua consulta foi agendada para {data} às {hora} com {profissional}. Em caso de dúvidas, entre em contato conosco.',
          variables: ['nome', 'data', 'hora', 'profissional'],
          active: true,
          category: 'confirmation',
          createdAt: '2024-06-20T10:00:00Z'
        },
        {
          id: 3,
          name: 'Pós-Consulta',
          content: 'Olá {nome}! Esperamos que sua consulta tenha sido proveitosa. Se tiver alguma dúvida sobre o tratamento, não hesite em nos contatar.',
          variables: ['nome'],
          active: true,
          category: 'followup',
          createdAt: '2024-06-20T10:00:00Z'
        }
      ],
      professionals: [
        {
          id: 1,
          name: 'Relatório Diário',
          content: 'Dr(a). {nome}, seguem as estatísticas do dia {data}: {consultas} consultas realizadas, {confirmacoes} confirmações recebidas, {cancelamentos} cancelamentos.',
          variables: ['nome', 'data', 'consultas', 'confirmacoes', 'cancelamentos'],
          active: true,
          category: 'report',
          createdAt: '2024-06-20T10:00:00Z'
        },
        {
          id: 2,
          name: 'Alerta de Agenda',
          content: 'Dr(a). {nome}, você tem {quantidade} consultas agendadas para amanhã ({data}). Primeira consulta às {primeiro_horario}.',
          variables: ['nome', 'quantidade', 'data', 'primeiro_horario'],
          active: true,
          category: 'alert',
          createdAt: '2024-06-20T10:00:00Z'
        }
      ]
    },
    messageHistory: [
      {
        id: 1,
        date: '2024-06-20',
        time: '14:30:00',
        type: 'schedule_confirmation',
        recipient: 'Maria Silva',
        recipientPhone: '+5511999999999',
        status: 'sent',
        channel: 'WhatsApp',
        content: 'Olá Maria! Lembramos que você tem consulta marcada para 21/06/2024 às 10:00 com Dr. João Silva.',
        cost: 0.50,
        templateId: 1,
        doctor: 'João',
        createdAt: '2024-06-20T14:30:00Z'
      },
      {
        id: 2,
        date: '2024-06-20',
        time: '08:00:00',
        type: 'daily_report',
        recipient: 'Dr. João Silva',
        recipientPhone: '+5511888888888',
        status: 'pending',
        channel: 'WhatsApp',
        content: 'Dr. João, seguem as estatísticas do dia 19/06/2024: 8 consultas realizadas, 6 confirmações recebidas.',
        cost: 0.50,
        templateId: 1,
        doctor: 'João',
        createdAt: '2024-06-20T08:00:00Z'
      },
      {
        id: 3,
        date: '2024-06-19',
        time: '16:45:00',
        type: 'post_care',
        recipient: 'Carlos Santos',
        recipientPhone: '+5511777777777',
        status: 'delivered',
        channel: 'WhatsApp',
        content: 'Olá Carlos! Esperamos que sua consulta tenha sido proveitosa.',
        cost: 0.50,
        templateId: 3,
        doctor: 'João',
        createdAt: '2024-06-19T16:45:00Z'
      }
    ],
    isLoading: false,
    isSaving: false,
    lastError: null,
    pagination: {
      page: 1,
      itemsPerPage: 10,
      totalItems: 0
    },
    filters: {
      dateRange: {
        start: null,
        end: null
      },
      status: null,
      channel: null,
      type: null
    }
  };
};

export const state = getDefaultState();

export const mutations = {
  [SET_DASHBOARD_STATS](state, stats) {
    state.dashboardStats = { ...state.dashboardStats, ...stats };
  },
  
  [SET_SECRETARY_CONFIG](state, config) {
    state.secretaryConfig = { ...state.secretaryConfig, ...config };
  },
  
  [SET_FAQ_ITEMS](state, faqItems) {
    state.faqItems = faqItems;
  },
  
  [ADD_FAQ_ITEM](state, faqItem) {
    state.faqItems.push({
      ...faqItem,
      id: Date.now(),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    });
  },
  
  [UPDATE_FAQ_ITEM](state, { id, updates }) {
    const index = state.faqItems.findIndex(item => item.id === id);
    if (index !== -1) {
      state.faqItems.splice(index, 1, {
        ...state.faqItems[index],
        ...updates,
        updatedAt: new Date().toISOString()
      });
    }
  },
  
  [DELETE_FAQ_ITEM](state, id) {
    state.faqItems = state.faqItems.filter(item => item.id !== id);
  },
  
  [SET_MESSAGE_TEMPLATES](state, templates) {
    state.messageTemplates = templates;
  },

  [SET_READONLY_SECRETARY](state, { readonlySecretary }) {
    state.readonlySecretary = readonlySecretary;
  },

  [SET_SECRETARY_STATS](state, stats) {
    state.stats = { ...state.stats, ...stats };
  },
  
  [ADD_MESSAGE_TEMPLATE](state, { type, template }) {
    if (!state.messageTemplates[type]) {
      state.messageTemplates[type] = [];
    }
    state.messageTemplates[type].push({
      ...template,
      id: Date.now(),
      createdAt: new Date().toISOString()
    });
  },
   
  [SET_MESSAGE_HISTORY](state, history) {
    state.messageHistory = history;
  },
  
  [ADD_MESSAGE_HISTORY](state, message) {
    state.messageHistory.unshift({
      ...message,
      id: Date.now(),
      createdAt: new Date().toISOString()
    });
  },
  
  [SET_LOADING](state, isLoading) {
    state.isLoading = isLoading;
  },
  
  [SET_SAVING](state, isSaving) {
    state.isSaving = isSaving;
  },
  
  [RESET](state) {
    Object.assign(state, getDefaultState());
  }
};

export const getters = {
  [GET_DASHBOARD_STATS](state) {
    return state.dashboardStats;
  },
  
  [GET_ACTIVE_SECRETARY_STATUS](state) {
    return state.secretaryConfig.isActive ? 'Ativa' : 'Inativa';
  },
  
  [GET_MONTHLY_USAGE_PERCENTAGE](state) {
    const { messages, monthlyLimit } = state.dashboardStats;
    return Math.round((messages / monthlyLimit) * 100);
  }, 
  
  [GET_SECRETARY_CONFIG](state) {
    return state.secretaryConfig;
  },

  GET_READONLY_SECRETARY(state) {
    return state.readonlySecretary;
  },

  [GET_SECRETARY_STATS](state) {
    return state.stats;
  },
  
  [GET_FAQ_ITEMS](state) {
    return state.faqItems;
  },
  
  [GET_ACTIVE_FAQ_ITEMS](state) {
    return state.faqItems.filter(item => item.active);
  },
  
  [GET_FAQ_CATEGORIES](state) {
    return [...new Set(state.faqItems.map(item => item.category))];
  },
  
  [GET_MESSAGE_TEMPLATES](state) {
    return state.messageTemplates;
  },
  
  [GET_MESSAGE_HISTORY](state) {
    return state.messageHistory;
  },
  
  [GET_RECENT_MESSAGES](state) {
    return state.messageHistory.slice(0, 5);
  },
  
  [GET_MESSAGES_BY_CHANNEL](state) {
    const channels = {};
    state.messageHistory.forEach(msg => {
      channels[msg.channel] = (channels[msg.channel] || 0) + 1;
    });
    return channels;
  },
  
  [GET_IS_LOADING](state) {
    return state.isLoading;
  },
  
  [GET_IS_SAVING](state) {
    return state.isSaving;
  }
};

export const actions = {
  async updateSecretaryVisitBlocked({getters, commit, dispatch}, { userId }) {
    const secretaryConfig = getters.GET_SECRETARY_CONFIG;
      
    if (!secretaryConfig?.visitBlocked) {
      return;
    }
  
    try {
      const token = await auth.currentUser.getIdToken();
      await api.post(`/secretary/visit-blocked/${userId}`,
        null,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      commit(SET_SECRETARY_CONFIG, {
        secretaryConfig: {
          ...secretaryConfig,
          visitBlocked: false,
        },
      });

      await dispatch('loadConfiguration', { id: userId });
    } catch (err) {
      console.log(err)
      const error = err.response.data;
      throw error;
    }
  },
  
  async loadConfiguration({ commit }, { id }) {
    const token = await auth.currentUser.getIdToken();

    try {      
      const response = await api.get(
        `/secretary/config/${id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      commit(SET_SECRETARY_CONFIG, response.data);
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async initializeConfiguration({ commit }, { id }) {
    const token = await auth.currentUser.getIdToken();

    try {      
      const response = await api.post(
        `/secretary/config/${id}/initialize`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      commit(SET_SECRETARY_CONFIG, response.data);
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async updateConfiguration({ commit }, { id, payload }) {
    const token = await auth.currentUser.getIdToken();

    try {      
      const response = await api.put(
        `/secretary/config/${id}`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      commit(SET_SECRETARY_CONFIG, payload);

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },
  
  async loadFaqItems({ commit }, { userId, payload }) {
    const token = await auth.currentUser.getIdToken();

    try {      
      const response = await api.get(
        `/secretary/faq/${userId}`,
        { 
          params: payload,
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      commit(SET_FAQ_ITEMS, response.data);

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },
  
  async createFaqItem(_, payload) {
    const token = await auth.currentUser.getIdToken();

    try {      
      const response = await api.post(
        '/secretary/faq',
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },
  
  async updateFaqItem(_, { id, payload }) {
    const token = await auth.currentUser.getIdToken();

    try {      
      const response = await api.put(
        `/secretary/faq/${id}`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },
  
  async deleteFaqItem(_, { id }) {
    const token = await auth.currentUser.getIdToken();

    try {      
      const response = await api.delete(
        `/secretary/faq/${id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async loadMessageTemplates() {
    const token = await auth.currentUser.getIdToken();

    try {      
      const response = await api.get(
        `/secretary/templates`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },
  
  async sendMessage({ commit }, messageData) {
    commit(SET_SAVING, true);
    
    try {
      await new Promise(resolve => setTimeout(resolve, 800));
      
      const message = {
        ...messageData,
        date: new Date().toISOString().split('T')[0],
        time: new Date().toTimeString().split(' ')[0],
        status: 'sent',
        cost: 0.50
      };
      
      commit(ADD_MESSAGE_HISTORY, message);
      
      const currentStats = state.dashboardStats;
      commit(SET_DASHBOARD_STATS, {
        messages: currentStats.messages + 1,
        cost: (parseFloat(currentStats.cost) + 0.50).toFixed(2)
      });
      
      return { success: true, message: 'Mensagem enviada!' };
    } catch (error) {
      console.error('Error sending message:', error);
      throw new Error('Erro ao enviar mensagem');
    } finally {
      commit(SET_SAVING, false);
    }
  },
  
  async executeProactiveCommand(_, { id, payload }) {
    const token = await auth.currentUser.getIdToken();
    
    try {
      const response = await api.post(
        `/secretary/commands/${id}`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async getProactiveCommand(_, { id }) {
    const token = await auth.currentUser.getIdToken();
    
    try {
      const response = await api.get(
        `/secretary/commands/${id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async loadActions(_ , { id, payload }) {
    const token = await auth.currentUser.getIdToken();

    try {      
      const response = await api.get(
        `/secretary/actions/${id}`,
        { 
          params: payload,
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },
  
  async loadAnalytics({ commit }, { id, payload }) {
    const token = await auth.currentUser.getIdToken();

    try {      
      const response = await api.get(
        `/secretary/stats/${id}`,
        { 
          params: payload,
          headers: { Authorization: `Bearer ${token}` } 
        }
      );

      commit(SET_SECRETARY_STATS, response.data);
      
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async loadMessages(_, { id }) {
    const token = await auth.currentUser.getIdToken();

    try {      
      const response = await api.get(
        `/secretary/messages/${id}`,
        { 
          headers: { Authorization: `Bearer ${token}` } 
        }
      );
      
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },
  
  reset({ commit }) {
    commit(RESET);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
